import { DeeplinksServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/deeplinks/DeeplinksServiceClientPb';

import {
  ListDeeplinksRequest,
  ListDeeplinksResponse,
  Deeplink,
  GetDeeplinkRequest,
  GetDeeplinkResponse,
  CreateDeeplinkRequest,
  CreateDeeplinkResponse,
  UpdateDeeplinkRequest,
  UpdateDeeplinkResponse,
  DeleteDeeplinkRequest,
  DeleteDeeplinkResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/deeplinks/deeplinks_pb';

export type DeeplinksExportClasses = {
  DeeplinksServiceClient: typeof DeeplinksServiceClient,
  ListDeeplinksRequest: typeof ListDeeplinksRequest,
  ListDeeplinksResponse: typeof ListDeeplinksResponse,
  Deeplink: typeof Deeplink,
  GetDeeplinkRequest: typeof GetDeeplinkRequest,
  GetDeeplinkResponse: typeof GetDeeplinkResponse,
  CreateDeeplinkRequest: typeof CreateDeeplinkRequest,
  CreateDeeplinkResponse: typeof CreateDeeplinkResponse,
  UpdateDeeplinkRequest: typeof UpdateDeeplinkRequest,
  UpdateDeeplinkResponse: typeof UpdateDeeplinkResponse,
  DeleteDeeplinkRequest: typeof DeleteDeeplinkRequest,
  DeleteDeeplinkResponse: typeof DeleteDeeplinkResponse,
};

export const deeplinks: DeeplinksExportClasses = {
  DeeplinksServiceClient,
  ListDeeplinksRequest,
  ListDeeplinksResponse,
  Deeplink,
  GetDeeplinkRequest,
  GetDeeplinkResponse,
  CreateDeeplinkRequest,
  CreateDeeplinkResponse,
  UpdateDeeplinkRequest,
  UpdateDeeplinkResponse,
  DeleteDeeplinkRequest,
  DeleteDeeplinkResponse,
};
